// eslint-disable-next-line
export default [
    {
        id: 1,
        productQtyIcon: '/svgs/singleProductIcon.svg'
    },
    {
        id: 2,
        productQtyIcon: '/svgs/singleProductIcon.svg'
    },
]